import { required, maxLength } from "vuelidate/lib/validators";

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    permissions: { required },
  },
};

export const validateComputed = {
  descriptionErrors() {
    const errors = [];
    if (!this.$v.form.description.$dirty) return errors;
    !this.$v.form.description.required &&
      errors.push("Descrição é obrigatória.");
    !this.$v.form.description.maxLength &&
      errors.push("A descrição deve ter menos do que 30 caracteres.");
    return errors;
  },
  permissionsErrors() {
    const errors = [];
    if (!this.$v.form.permissions.$dirty) return errors;
    !this.$v.form.permissions.maxLength &&
      errors.push("Ao menos uma permissão é obrigatória.");
    return errors;
  },
};
